import {CalculationType} from "../../../_models/_general/calculation-type";

export class SalaryModifier {
  id: string = "";
  calculationType: CalculationType = CalculationType.AbsolutePerHour;
  value: number = 0;
}
